// Translation: Reset > Landing > Form (Ukrainian)
export default Object.freeze({
	form: {
		actions: {
			changePassword: '',
			continue: ''
		},
		fields: {
			code: {
				placeholder: ''
			},
			email: {
				placeholder: ''
			},
			password: {
				options: {
					hide: {
						label: ''
					},
					show: {
						label: ''
					}
				},
				placeholder: ''
			},
			passwordConfirmation: {
				placeholder: ''
			}
		},
		options: {
			resendCode: {
				label: {
					idle: '',
					success: ''
				}
			}
		},
		title: {
			codeVerification: '',
			information: '',
			passwordReset: ''
		}
	}
})
